import { ADD_ITEM_TO_SHOPPING } from '../actions/ShoppingCartActions'

const initialState = {
    items: {
        /*
        [itemId]: {
            itemId: <ITEM-ID>,
            amount: <AMOUNT-OF-ITEMS>
        },
        */
    }
}

const ScrollReducer = (state = initialState, action) => {
    switch(action.type) {
        case ADD_ITEM_TO_SHOPPING:
            const curAmount = state.items[action.itemId].amount;
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.itemId]: {
                        itemId: action.itemId,
                        amount: curAmount ? (curAmount + action.amount) : action.amount,
                    }
                }
            }
        default:
            return state;
    }
}

export default ScrollReducer;